import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa';
import { FaWallet } from 'react-icons/fa6';
import s from './NavBar.css';
import SearchBar from '../SearchBar';
import ProfileMenu from '../ProfileMenu';
import AnimatedButton from '../Buttons/AnimatedButton';
const mapStateToProps = (state) => ({
    user: state.auth.user,
    isAuthenticated: state.auth.isAuthenticated,
});
const connector = connect(mapStateToProps);
class NavBar extends Component {
    state = {
        active: false,
        border: false,
        visible: false,
    };
    componentDidMount() {
        if (window.innerHeight > window.innerWidth) {
            document.getElementById('menu')?.addEventListener('click', this.handleMenuClick);
        }
    }
    handleMenuClick = () => {
        const container = document.getElementById('container');
        if (container?.classList.contains('NavBar__navActive___sBqdn')) {
            container.classList.remove('NavBar__navActive___sBqdn');
            this.setState({ active: false });
            setTimeout(() => this.setState({ border: false }), 900);
        }
        else {
            container?.classList.add('NavBar__navActive___sBqdn');
            this.setState({ border: true, active: true });
        }
    };
    render() {
        const isDesktop = window.innerWidth > window.innerHeight;
        const isVault = window.location.pathname.includes('vault');
        const { user, isAuthenticated } = this.props;
        const edgeStyle = isVault || user ? s.shadow : s.border;
        return (React.createElement("div", { className: `${s.headerContainer} ${edgeStyle}`, id: 'container', role: 'button', tabIndex: 0, onClick: () => this.setState({ visible: false }), onKeyDown: (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    this.setState({ visible: false });
                }
            } },
            React.createElement(Link, { to: user ? '/vault/files' : '/', className: s.sticknetContainer },
                React.createElement("p", { className: s.sticknet }, "Sticknet")),
            isVault && React.createElement(SearchBar, null),
            isDesktop ? (isVault || isAuthenticated ? (React.createElement(ProfileMenu, { visible: this.state.visible, setVisible: (value) => this.setState({ visible: value }) })) : (!isAuthenticated && (React.createElement("div", { className: s.headerRightContainer },
                React.createElement("a", { className: s.headerLink, href: `${window.location.origin}#get-sticknet` },
                    React.createElement("span", null, "Get Sticknet")),
                React.createElement(Link, { className: s.headerLink, to: '/faq' },
                    React.createElement("span", null, "FAQ")),
                React.createElement(Link, { className: s.headerLink, to: '/support' },
                    React.createElement("span", null, "Support")),
                React.createElement(Link, { className: s.headerLink, to: '/premium' },
                    React.createElement("span", null, "Pricing")),
                isAuthenticated ? (React.createElement(ProfileMenu, { visible: this.state.visible, setVisible: (value) => this.setState({ visible: value }) })) : (React.createElement(AnimatedButton, { icon: React.createElement(FaWallet, { color: '#ffffff', size: 18 }), text: 'Login', to: '/portal-login' })))))) : (React.createElement("div", { className: s.menuIcon, id: 'menu', role: 'button', tabIndex: 0, "aria-label": 'Menu' },
                React.createElement("span", { className: `${s.menuIconLine} ${s.menuIconLineLeft}` }),
                React.createElement("span", { className: s.menuIconLine }),
                React.createElement("span", { className: `${s.menuIconLine} ${s.menuIconLineRight}` }))),
            !isDesktop && (React.createElement("div", { className: s.menuContainer, style: {
                    maxHeight: !this.state.active ? 0 : '60vh',
                    borderTop: this.state.border ? 'lightgrey 1px solid' : '',
                }, role: 'menu', "aria-label": 'Mobile Menu' },
                React.createElement(Link, { onClick: this.handleMenuClick, className: `${s.headerLink} ${s.headerLink1}`, to: '/premium', tabIndex: 0, role: 'menuitem' },
                    React.createElement("span", null, "Pricing")),
                React.createElement("a", { onClick: this.handleMenuClick, className: `${s.headerLink}`, href: `${window.location.origin}#get-sticknet`, tabIndex: 0, role: 'menuitem' },
                    React.createElement("span", null, "Get Sticknet")),
                React.createElement(Link, { onClick: this.handleMenuClick, className: s.headerLink, to: '/faq', tabIndex: 0, role: 'menuitem' },
                    React.createElement("span", null, "FAQ")),
                React.createElement(Link, { onClick: this.handleMenuClick, className: s.headerLink, to: '/support', tabIndex: 0, role: 'menuitem' },
                    React.createElement("span", null, "Support")),
                React.createElement("a", { onClick: this.handleMenuClick, className: s.headerLink, target: '_blank', href: 'https://www.linkedin.com/company/sticknet/', rel: 'noreferrer', tabIndex: 0, role: 'menuitem', "aria-label": 'LinkedIn' },
                    React.createElement(FaLinkedin, { className: s.icon }))))));
    }
}
export default connector(NavBar);
